module.exports = "/_next/static/images/lightbulb-9f6dad30c83eece673c66b60de1dfe9b.svg";